import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ViewJobPageLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ViewJobPage" */
      './ViewJobPage.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
